import React from 'react'
import { Link } from 'react-router-dom'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import Swal from 'sweetalert2'
import Constant from '../../Constant'
class PickUpList extends React.Component {
  state = {
    Products_data: {},
    isloading: false,
    cat: this.props.match.params.boatType,
    isData: false,
  }
  StyleForDetail = {
    marginBottom: '6px',
    letterSpacing: '0.5px',
    display: 'inline-block',
  }
  componentDidMount() {
    this.dashbord()
  }
  dashbord = async () => {
    var that = this
    this.setState({ isloading: true })
    var cruiseId = this.props.match.params.boatId

    await axios
      .get(Constant.getAPI() + `/cruise/get-pick-up/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ isloading: false })
          that.setState({
            Products_data: res.data.data,
          })
          if (this.state.Products_data.id) {
            this.setState({ isData: true })
          }
        }
      })
      .catch((err) => {
        this.setState({ isloading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>{this.props.match.params.boatType} PickUp </h4>
                    </div>
                  </div>
                  <div>
                    {this.state.isData ? (
                      <Link
                        to={
                          `/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/pickup-add/` +
                          this.state.Products_data.id
                        }
                        className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                        data-modal="modal-13"
                      >
                        <i className="icofont icofont-plus m-r-5"></i>
                        {this.props.match.params.boatType} PickUp Edit
                      </Link>
                    ) : null}
                  </div>
                  <div
                    style={{
                      display: 'inline-block',
                      float: 'right',
                      marginRight: '30px',
                    }}
                  >
                    <Link
                      to={`/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/pickup-add`}
                      className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                      data-modal="modal-13"
                    >
                      <i className="icofont icofont-plus m-r-5"></i>
                      {this.props.match.params.boatType} PickUp Add
                    </Link>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link
                          to={`/viewboat-details/${this.props.match.params.boatType}/${this.props.match.params.boatId}`}
                        >
                          {this.props.match.params.boatType} Details{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">{this.props.match.params.boatType} PickUp</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <table className="details">
                          <tbody>
                            {this.state.isLoading ? (
                              'Loading...'
                            ) : (
                              <div>
                                {this.state.Products_data ? (
                                  <div>
                                    <tr>
                                      <th style={this.StyleForDetail}>Address: English</th>
                                      <td>{this.state.Products_data.pickup_address_en}</td>
                                    </tr>
                                    <tr>
                                      <th style={this.StyleForDetail}>Address: Arabic</th>
                                      <td>{this.state.Products_data.pickup_address_ar}</td>
                                    </tr>
                                    <tr>
                                      <th style={this.StyleForDetail}>Description</th>
                                      <td>{this.state.Products_data.pickup_desc}</td>
                                    </tr>
                                    <tr>
                                      <th style={this.StyleForDetail}>Latitude</th>
                                      <td>{this.state.Products_data.pickup_lat}</td>
                                    </tr>
                                    <tr>
                                      <th style={this.StyleForDetail}>Longitude</th>
                                      <td>{this.state.Products_data.pickup_long}</td>
                                    </tr>
                                    <tr>
                                      <th style={this.StyleForDetail}>Map</th>
                                      <td>{this.state.Products_data.pickup_map}</td>
                                    </tr>
                                    <tr>
                                      <th style={this.StyleForDetail}>Other Details</th>
                                      <td>{this.state.Products_data.pickup_other_detail}</td>
                                    </tr>
                                    <tr>
                                      <th style={this.StyleForDetail}>Port Fee Type</th>
                                      <td>{this.state.Products_data.port_fee_type}</td>
                                    </tr>
                                    <tr>
                                      <th style={this.StyleForDetail}>Port Fee</th>
                                      <td>{this.state.Products_data.port_fee}</td>
                                    </tr>
                                  </div>
                                ) : (
                                  'No result found...'
                                )}
                              </div>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PickUpList
